




























































import {Component, Vue} from "vue-property-decorator";
import MainPaneTemplate from "@/components/templates/loggedin/MainPaneTemplate.vue";
import PasswordlessService from "@/components/domains/auth/passwordlessService";
import PasskeyService, {
  CEREMONY_CANCELLED,
  passkeyErrorMessage,
  passkeyErrorReason,
  PASSKEY_MESSAGES,
} from "@/components/domains/auth/passkeyService";
import {AuthPolicy} from "@/components/domains/auth/authPolicy";
import {deviceNickname, formatDeviceDate, MAX_PASSKEYS, Passkey} from "@/components/domains/auth/webauthnJson";

/** Signed-in: the devices that can sign in with a fingerprint / face. */
@Component({
  components: {MainPaneTemplate}
})
export default class Passkeys extends Vue {
  name = "Passkeys";

  policy: AuthPolicy | null = null;
  supported = PasskeyService.isSupported();
  items: Passkey[] = [];
  loaded = false;
  busy = false;
  adding = false;
  confirmingId: string | null = null;
  msg: { tone: 'ok' | 'err'; text: string } | null = null;
  max = MAX_PASSKEYS;

  get atLimit(): boolean {
    return this.items.length >= MAX_PASSKEYS;
  }

  date(iso: string | null): string {
    return formatDeviceDate(iso);
  }

  mounted(): void {
    PasswordlessService.loadPolicy({fresh: true}).then((p) => {
      this.policy = p;
      if (p.passkeyAvailable) this.load();
    });
  }

  async load(): Promise<void> {
    try {
      this.items = await PasskeyService.list();
    } catch (e) {
      this.msg = {tone: 'err', text: passkeyErrorMessage(e, PASSKEY_MESSAGES.failed)};
    }
    this.loaded = true;
  }

  async add(): Promise<void> {
    if (this.busy || this.adding) return;
    this.msg = null;
    this.confirmingId = null;
    this.adding = true;
    try {
      const pk = await PasskeyService.register(deviceNickname(navigator.userAgent));
      this.items = this.items.concat([pk]);
      this.msg = {tone: 'ok', text: 'この端末を登録しました。次からは、指紋や顔でログインできます。'};
      this.$root.$emit('passkey-registered');
    } catch (e) {
      // A cancelled fingerprint / face prompt is not worth a red message.
      if (passkeyErrorReason(e) !== CEREMONY_CANCELLED) {
        this.msg = {tone: 'err', text: passkeyErrorMessage(e, PASSKEY_MESSAGES.failed)};
      }
    } finally {
      this.adding = false;
    }
  }

  askRemove(id: string): void {
    this.msg = null;
    this.confirmingId = id;
  }

  async remove(id: string): Promise<void> {
    if (this.busy) return;
    this.msg = null;
    this.busy = true;
    try {
      await PasskeyService.remove(id);
      this.items = this.items.filter((p) => p.id !== id);
      this.msg = {tone: 'ok', text: '登録を削除しました。'};
    } catch (e) {
      this.msg = {tone: 'err', text: passkeyErrorMessage(e, PASSKEY_MESSAGES.failed)};
    } finally {
      this.busy = false;
      this.confirmingId = null;
    }
  }
}
